export { default as RatingBar } from './RatingBar';
